import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/material/icon";
export class AccessDeniedComponent {
    constructor(route) {
        this.route = route;
    }
    ngOnInit() {
        this.defaultMsg = {
            title: 'Sorry! Access Denied',
            icon: 'lock',
            description: 'Missing something? Please reach out to your administrator for application permissions'
        };
        this.route.data.subscribe(value => {
            if (value && value['title'] && value['icon'] && value['description']) {
                this.data = value;
            }
            else {
                this.data = this.defaultMsg;
            }
        });
    }
    static { this.ɵfac = function AccessDeniedComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccessDeniedComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccessDeniedComponent, selectors: [["app-access-denied"]], standalone: false, decls: 14, vars: 3, consts: [[1, "access-wrapper"], [1, "align-icon"], [3, "innerHTML"]], template: function AccessDeniedComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtext(1, "\n    ");
            i0.ɵɵelementStart(2, "h1");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4, "\n    ");
            i0.ɵɵelementStart(5, "div", 1);
            i0.ɵɵtext(6, "\n        ");
            i0.ɵɵelementStart(7, "mat-icon");
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(9, "\n    ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(10, "\n    ");
            i0.ɵɵelementStart(11, "h3", 2);
            i0.ɵɵtext(12, "\n    ");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(13, "\n");
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.data.title);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1("\n            ", ctx.data.icon, "\n        ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHTML", ctx.data.description, i0.ɵɵsanitizeHtml);
        } }, dependencies: [i2.MatIcon], styles: ["\n\nh1[_ngcontent-%COMP%] {\n  text-align: center;\n  color: #616C7D;\n  font-weight: 400;\n}\nh3[_ngcontent-%COMP%] {\n  text-align: center;\n  color: #9b9c9f;\n  font-weight: 400;\n}\n.access-wrapper[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%] {\n  overflow: visible;\n}\n.mat-icon[_ngcontent-%COMP%] {\n  color: #dce2ea;\n  font-size: 320px;\n  height: 320px;\n  width: 320px;\n  line-height: 320px;\n}\n.align-icon[_ngcontent-%COMP%] {\n  text-align: center;\n}\n.access-wrapper[_ngcontent-%COMP%] {\n  margin-top: 40px;\n}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(AccessDeniedComponent, { className: "AccessDeniedComponent", filePath: "libs/web/angular/shared/util/error-handling/src/lib/access-denied/access-denied.component.ts", lineNumber: 10 }); })();
//# sourceMappingURL=access-denied.component.js.map